export default "__VITE_ASSET__ACTrwzW$__"